// TODO use OTel types here?
export const vars = {
    endpoints: [],
    resource: {
        attributes: [],
    },
    scope: {
        name: "dash0-web-sdk",
        version: __sdkVersion,
        attributes: [],
    },
    signalAttributes: [],
    ignoreUrls: [],
    ignoreErrorMessages: [],
    wrapEventHandlers: true,
    wrapTimers: true,
    propagateTraceHeadersCorsURLs: [],
    maxWaitForResourceTimingsMillis: 10000,
    maxToleranceForResourceTimingsMillis: 3000,
    headersToCapture: [],
    pageViewInstrumentation: {
        trackVirtualPageViews: true,
        includeParts: [],
    },
};
